/**
 * @name MessagesController
 * @description The controller for inbox messages
 * @param {service} Session Unknown
 * @param {service} Events The Participants service
 * @param {service} $log Angular $log service
 * @param {service} $state Angular $log service
 * @param {library} moment The moment library
 * @param {service} Participants The Participants service
 * @param {library} _ The lodash library
 * @param {Angular} $scope The Angular $scope service
 * @param {Angular} $q The Angular $q service
 * @param {service} GroupParticipants The GroupParticipants service
 * @param {service} Appointment The Appointment service
 * @param {Angular} $rootScope The Angular $rootScope service
 * @param {service} Conversations The Conversations service
 */
function MessagesController(
  Session,
  Events,
  $log,
  $state,
  moment,
  Participants,
  _,
  $scope,
  $q,
  GroupParticipants,
  Appointment,
  $rootScope,
  Conversations
) {
  let vm = this;
  vm.$onInit = function() {
    vm.session = Session;
    vm.events = Events;
    vm.loadConversation = loadConversation;
    vm.archive = archive;
    vm.unArchive = unArchive;
    vm.getParticipants = getParticipants;
    vm.uiOnParamsChanged = uiOnParamsChanged;
    vm.loadPage = loadPage;
    vm.loading = false;
    vm.page = vm.$transition$.params().page;
  };

  // Get the unread count on load
  getUnreadCount();

  /**
   * @name getUnreadCount
   * @description Function to get the unread count of participants for the
   * logged in user
   */
  function getUnreadCount() {
    Participants.getUnreadCount().then(function(count) {
      Events.newMessagesCount = count;
    });
  }

  /**
   * @name loadConversation
   * @description Function to select a conversation and get the appointment and
   * project
   * @param {type} participant The participant to update
   */
  function loadConversation(participant) {
    $state.go('inkfinder.messages.conversations',
    {conversationId: participant.conversation});
    let formattedParticipant = {
      id: participant.id,
      last_read_date: moment.utc().format('YYYY-MM-DDTHH:mm:ss')
    };
    Participants.update(formattedParticipant);
  }

  /**
   * @name archive
   * @description Function to update the the read boolean and last read date for
   * a participant effectively archiving the participant object
   * @param {array} participant The participant to archive
   */
  function archive(participant) {
    // read:true is how we flag an archived message
    participant.read = true;
    // Set the last read date to now when archiving
    participant.last_read_date = moment.utc().format('YYYY-MM-DDTHH:mm:ss');
    Participants.update(participant).then(function(updatedParticipant) {
      _.remove(vm.participants.results, function(participant) {
        return participant.id === updatedParticipant.id;
      });
      const type = 'inbox';
      getParticipants(type);
    });
  }

  /**
   * @name unArchive
   * @description Function to update the the read boolean and last read date for
   * a participant to move it to the inbox
   * @param {array} participant The participant to unarchive
   */
  function unArchive(participant) {
    // read:true is how we flag an archived message
    participant.read = false;
    // Set the last read date to now when archiving
    participant.last_read_date = moment.utc().format('YYYY-MM-DDTHH:mm:ss');
    Participants.update(participant).then(function(updatedParticipant) {
      _.remove(vm.participants.results, function(participant) {
        return participant.id === updatedParticipant.id;
      });
      const type = 'archive';
      getParticipants(type);
    });
  }

  /**
   * @name getNewParticipants
   * @description Function to get archived participants. This is called when
   * this controller loads so participants with unread messages load first.
   * @param {string} type The type of participants to get. Inbox or Archive.
   */
  function getParticipants(type) {
    vm.loading = true;
    let collectorId = Session.collector.id;
    let conversationId;
    let appointmentId;
    let read = 'False';
    if (type === 'archive') {
      read = 'True';
    }
    let page = getCurrentPage();
    let sort = 'last_message_date';
    let lastMessage = 'notnull';
    Participants
    .get(
    conversationId,
    appointmentId,
    collectorId,
    read,
    page,
    sort,
    lastMessage)
    .then(function(participants) {
      vm.participants = participants;
      vm.loading = false;
      getUnreadCount();
    });
  }

  /**
   * @name getCurrentPage
   * @description Function to get the last page of results to avoid page not
   * found errors when calling the API
   * @return {string} Returns the page number (as a string) of the last page
   */
  function getCurrentPage() {
    if (vm.participants.results.length === 0 && vm.page > 1) {
      vm.page = (vm.page - 1).toString();
    }
    return vm.page;
  }

  /**
   * @name uiOnParamsChanged
   * @description A ui-router function callback when param values change.
   * @param {object} newParams The params change
   */
  function uiOnParamsChanged(newParams) {
    vm.page = newParams.page;
    $state.go('.', {page: vm.page}, {reload: true});
  }

  /**
   * @name loadPage
   * @description Updates the page number and calls $state.go to update the URL
   * with the new page number.
   * @param {number} page The new page number.
   */
  function loadPage(page) {
    vm.page = page.toString();
    $state.go('.', {page: vm.page}, {reload: true});
  }
}

angular
  .module('inkfinder')
  .controller('MessagesController', MessagesController);



// WEBPACK FOOTER //
// ./components/messages/messages.controller.js